

export default function useToken() {
    const tokenString = localStorage.getItem('token');
    //const userToken = JSON.parse(tokenString);
    // if()
    return tokenString;
  }
